import { render, staticRenderFns } from "./SettingsSponsors.vue?vue&type=template&id=57e8c7c9&scoped=true&"
import script from "./SettingsSponsors.vue?vue&type=script&lang=js&"
export * from "./SettingsSponsors.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSponsors.vue?vue&type=style&index=0&id=57e8c7c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e8c7c9",
  null
  
)

export default component.exports